module.exports = __webpack_public_path__ + "media/images/badge/supercoppa-vincente_secondary-3d95bc9e4ced2e1168b14dd7df5def83.png";